class VccProductLayout extends HTMLElement {
  connectedCallback() {
    if (this.dataset.vccLayoutReady === 'true') return;
    this.dataset.vccLayoutReady = 'true';
    this.observer = new ResizeObserver(([entry]) => {
      const threshold = Number(this.dataset.stackWidth || 900);
      this.classList.toggle('vcc-is-stacked', entry.contentRect.width <= threshold && innerWidth >= 750);
    });
    this.observer.observe(this);
  }
  disconnectedCallback() { this.observer?.disconnect(); delete this.dataset.vccLayoutReady; }
}
if (!customElements.get('vcc-product-layout')) customElements.define('vcc-product-layout', VccProductLayout);
